module.exports = __webpack_public_path__ + "img/slide-img-3.381fe0f2.png";